document.addEventListener("DOMContentLoaded", function () {

  // Poczekaj aż menu się rzeczywiście pojawi (bo Shopify otwiera je dopiero po kliknięciu)
  const observer = new MutationObserver(() => {
    const ul = document.querySelector('#MegaMenu-Content-1 .mega-menu__list');
    if (ul && !document.querySelector('#MegaMenu-Content-1 .mega-menu-image')) {

      // Tworzymy <a>
      const link = document.createElement('a');
      link.href = "https://haxe.pl/products/masazer-pod-oczy-haxe-glorie-hx805"; // <-- TUTAJ TWÓJ LINK
      link.classList.add('mega-menu-image');
      

      // Tworzymy <img>
      const img = document.createElement('img');
      img.src = "https://cdn.shopify.com/s/files/1/0885/5630/6781/files/10_d60d685e-7090-47f9-9a87-b65ff7bb8816.png?v=1763018511"; // <-- TUTAJ URL OBRAZKA
      img.alt = "Promowane produkty";
      img.style.borderRadius = "10px";
      

      // Dodaj obrazek do <a>
      link.appendChild(img);

      // Wstaw <a> PO UL
      ul.insertAdjacentElement("afterend", link);
    }
  });

  // Obserwujemy cały dokument bo element pojawia się dopiero po kliknięciu
  observer.observe(document.body, { childList: true, subtree: true });

});
